<template>
  <div class="f fs ft fcol gap20">
    <div class="card card-dark spray-container">
      <component :is="dynamicComponent" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ name: string }>()
const dynamicComponent = shallowRef(null);

async function importSpray(spray: string) {
  try {
    const component = await import(`./spray/${spray}.vue`);
    return component.default;
  } catch (error) {
    console.error(`Error loading spray component: ${error}`);
    return null;
  }
}

dynamicComponent.value = await importSpray(props.name);

watch(() => props.name, async (newName) => {
  dynamicComponent.value = await importSpray(newName);
});
</script>

<style scoped>
.spray-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    min-height: 350px;
    max-height: 450px;

    &:deep(path) {
      animation: dashAnimation 5s linear infinite;

    }
  }
}

@keyframes dashAnimation {
  from {
    stroke-dashoffset: 100000;
  }
  to {
    stroke-dashoffset: 0;
  }
}
</style>
